<div
  class="form-group"
  [class.has-danger]="(isInvalid && isTouched) || (hasErrors$ | async)"
  [class.has-success]="!isInvalid"
  [ngClass]="classNames"
>
  <ng-content select="cf-input-label, [input-label]"></ng-content>
  <ng-content select="label"></ng-content>
  <ng-content select="cf-input-error[top]"> </ng-content>
  <div
    class="input-group"
    [class.is-touched]="isTouched"
    [class.is-invalid]="hasError"
    [class.is-success]="!hasError && hasSuccess"
    [class.is-focused]="inputDir.focused$ | async"
    [class.is-disabled]="disabled$ | async"
  >
    <ng-content select="[cf-input-prefix]"></ng-content>
    <ng-content select="[cf-input]"></ng-content>
    <ng-content select="[cf-input-suffix]"></ng-content>
    <ng-content></ng-content>
  </div>

  <div *ngIf="hasError">
    <ng-content select="cf-input-error"> </ng-content>
    <ng-content select=".input-error"> </ng-content>
  </div>
  <ng-content select="[customError]"> </ng-content>
  <ng-content select="[inputHint]"> </ng-content>
</div>
